package com.sddamico.api

import kotlinx.browser.window
import kotlinx.coroutines.await
import kotlinx.serialization.DeserializationStrategy
import kotlinx.serialization.json.Json
import org.w3c.fetch.RequestInit
import kotlin.js.json

class ApiException(val status: Int, val errorMessage: String) : Exception(errorMessage)

val apiJson = Json { ignoreUnknownKeys = true }

suspend fun <T> apiGet(url: String, deserializer: DeserializationStrategy<T>): T {
    val init = js("{}").unsafeCast<RequestInit>()
    init.method = "GET"
    init.headers = json("Accept" to "application/json")
    init.asDynamic().credentials = "same-origin"

    val response = window.fetch(url, init).await()
    val text = response.text().await()

    if (!response.ok) {
        val errorMsg = try {
            apiJson.decodeFromString(ErrorResponse.serializer(), text)
        } catch (_: Exception) {
            null
        }
        throw ApiException(response.status.toInt(), errorMsg?.error ?: "Request failed with status ${response.status}")
    }

    return apiJson.decodeFromString(deserializer, text)
}

suspend fun <T> apiPost(
    url: String,
    body: String?,
    deserializer: DeserializationStrategy<T>,
): T {
    val init = js("{}").unsafeCast<RequestInit>()
    init.method = "POST"
    init.headers = json(
        "Accept" to "application/json",
        "Content-Type" to "application/json",
    )
    init.asDynamic().credentials = "same-origin"
    if (body != null) {
        init.body = body
    }

    val response = window.fetch(url, init).await()
    val text = response.text().await()

    if (!response.ok) {
        val errorMsg = try {
            apiJson.decodeFromString(ErrorResponse.serializer(), text)
        } catch (_: Exception) {
            null
        }
        throw ApiException(response.status.toInt(), errorMsg?.error ?: "Request failed with status ${response.status}")
    }

    return apiJson.decodeFromString(deserializer, text)
}
